import { store } from 'index'


export default () => `shoppingListItems_${store.getState().configuration.partner.id}`
